<td *ngIf="roles?.length === 1">{{ roles[0].name }}</td>
<td *ngIf="roles?.length > 1">
    <ng-select
        [items]="roles"
        [(ngModel)]="rpicRoleId"
        [ngModelOptions]="{ standalone: true }"
        [disabled]="disable || readonly"
        [clearable]="false"
        bindValue="id"
        bindLabel="name"
        placeholder="Select a role"
        appendTo="body"
        class="wide-panel"
        (change)="onUpdate()"
    >
    </ng-select>
</td>
<td *ngIf="!selectPerson">
    <div class="horizontal-container vertical-align space-between">
        <div class="horizontal-container">
            <action-required *ngIf="rpicNotInOrg"
                >The selected person is no longer available as part of the
                organisation personnel</action-required
            >
            <action-required *ngIf="rpicMissingRole"
                >The selected person does not currently hold a pilot role and/or
                licence in this organisation</action-required
            >
            <a
                *ngIf="
                    !disable &&
                    !readonly &&
                    crewLookup &&
                    crewLookup[rpicId] != null
                "
                (click)="showPersonDetails.emit(rpicId)"
                >{{ crewLookup ? crewLookup[rpicId] : '' }}
            </a>
            <span
                *ngIf="
                    (disable || readonly) &&
                    crewLookup &&
                    crewLookup[rpicId] != null
                "
                >{{ crewLookup[rpicId] }}</span
            >
            <span *ngIf="crewLookup && crewLookup[rpicId] == null"
                >Unknown Person</span
            >
        </div>
        <button
            *ngIf="!disable && !readonly"
            type="button"
            class="btn btn-tertiary"
            tooltip="Select a different person"
            placement="top"
            (click)="selectPerson = !selectPerson"
        >
            <span class="fal fa-pencil-alt"></span>
        </button>
    </div>
</td>
<td *ngIf="selectPerson">
    <div class="horizontal-container vertical-align">
        <ng-select
            [items]="pilots"
            [(ngModel)]="rpicId"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="disable || readonly"
            [clearable]="false"
            bindValue="id"
            placeholder="Select a person"
            groupBy="registerWithWorkgroupStatus"
            (change)="onUpdate()"
            appendTo="body"
            class="wide-panel fill"
            [searchFn]="personSearch"
            [loading]="loadingPersonnel"
            [virtualScroll]="true"
            (scrollToEnd)="onPilotSelectScroll()"
            (search)="onPilotSelectSearch($event)"
            (close)="onPilotSelectClose()"
        >
            <ng-template ng-label-tmp let-item="item">
                {{
                    item?.firstName && item?.lastName != null
                        ? (item | formatPerson)
                        : crewLookup[rpicId] ?? 'Unknown Person'
                }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-index="index">
                {{ item | formatPerson }}
            </ng-template>
        </ng-select>
        <button
            *ngIf="rpicId != null"
            type="button"
            class="btn btn-tertiary no-margin"
            tooltip="Cancel"
            placement="top"
            (click)="selectPerson = !selectPerson"
            [disabled]="disable || readonly"
        >
            <span class="fal fa-times"></span>
        </button>
    </div>
</td>
<ng-container
    *ngIf="
        showStatus &&
        !pilotRegisterDisabled &&
        !isLoading &&
        getPilotRegisterStatus(rpicId) as status
    "
    [ngSwitch]="status"
>
    <td *ngFor="let id of authorityIds">
        <span *ngSwitchCase="null"></span>
        <span *ngIf="registerEntriesOnMissionLoading">Loading...</span>
        <span *ngSwitchDefault>
            <ng-container *ngIf="!registerEntriesOnMissionLoading">
                <pilot-register-details-overall-status
                    [pilotId]="rpicId"
                    [status]="status[id] ? status[id] : 'N/A'"
                    [authorityId]="id"
                ></pilot-register-details-overall-status>
                <button
                    *ngIf="hasRpa && status[id] && status[id] !== 'N/A'"
                    type="button"
                    class="btn btn-tertiary"
                    (click)="toggleShowPilotRegisterDetails()"
                >
                    <span
                        class="fa"
                        [ngClass]="{
                            'fa-chevron-down': !showRpicRegisterDetails,
                            'fa-chevron-up': showRpicRegisterDetails
                        }"
                        [tooltip]="
                            (showRpicRegisterDetails ? 'Hide ' : 'Show more ') +
                            'register status information'
                        "
                        placement="top"
                    ></span>
                </button>
            </ng-container>
        </span>
    </td>
</ng-container>
<ng-container
    *ngIf="
        showStatus &&
        (pilotRegisterDisabled || !rpicId || !getPilotRegisterStatus(rpicId))
    "
>
    <ng-container *ngIf="!isLoading">
        <td>
            {{ pilotRegisterDisabled || rpicId ? 'N/A' : '' }}
        </td>
    </ng-container>
    <ng-container *ngIf="isLoading">
        <td>Loading...</td>
    </ng-container>
</ng-container>
<td></td>
